/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { getAPI } from "../../../utils/common";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Space, Button, Card, Layout, Table, Tag } from "antd";
import dayjs from "dayjs";

import { ALL_LAUNDRY_OUT } from "../../../constants/api";

function LaundryOutTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);

    const successFn = (data) => {
      if (data.status === true) {
        const formatted = data.data.map((row, index) => ({
          key: index,
          ID: index + 1,
          Vendor: row.vendor?.name || "-",
          Date: dayjs(row.out_date).format("DD MMM YYYY"),
          Amount: `₹ ${row.total_amount}`,
          Status: (
            <Tag color={row.status === "pending" ? "orange" : "green"}>
              {row.status.toUpperCase()}
            </Tag>
          ),
          Action: (
            <Space>
              <Button
                size="small"
                onClick={() => navigate("/laundry/in/add/" + row.id)}
                disabled={row.status === "completed"}
              >
                Receive
              </Button>

              <Button
                size="small"
                onClick={() => navigate("/laundry/out/view/" + row.id)}
              >
                View
              </Button>
            </Space>
          ),
        }));

        setState(formatted);
      } else {
        setState([]);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setState([]);
      setLoading(false);
    };

    getAPI(ALL_LAUNDRY_OUT, successFn, errorFn, {});
  };

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 70 },
    { title: "Vendor", dataIndex: "Vendor", width: 200 },
    { title: "Out Date", dataIndex: "Date", width: 150 },
    { title: "Total Amount", dataIndex: "Amount", width: 150 },
    { title: "Status", dataIndex: "Status", width: 120 },
    { title: "Action", dataIndex: "Action", width: 200 },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Laundry Out List"
          extra={
            <Button onClick={() => navigate("/laundry/out/add")}>
              Add <PlusOutlined />
            </Button>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={state}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 800 }}
          />
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default LaundryOutTable;
